import { render, staticRenderFns } from "./generalHealth.vue?vue&type=template&id=3e484d38&scoped=true"
import script from "./generalHealth.vue?vue&type=script&lang=js"
export * from "./generalHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e484d38",
  null
  
)

export default component.exports